export const version = '1.5.17';
export const buildDate = '2026-11-02T11:21:32.581Z';
export const commitHash = '1e033dc6b';